import React, { useState } from "react";
import { ArrayField, Button, Datagrid, SelectField, SimpleShowLayout, TextField } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { ExamCommissionRoles } from "utils/choices";
import ProfessorField from "server/components/Fields/ProfessorField";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import ProfessorsCommissionEditForm from "./ProfessorsCommissionEditForm";
import { SectionTitle } from "features/SectionTitle";

const ProfessorsCommission = ({ record }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  const [isProfessorEditing, setIsProfessorEditing] = useState(false);

  const handleProfessorEditClick = () => {
    setIsProfessorEditing(true);
  };

  return (
    <>
      <SectionTitle
        title="Преподаватели"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <SimpleShowLayout>
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          {isProfessorEditing ? (
            <ProfessorsCommissionEditForm
              setIsProfessorEditing={setIsProfessorEditing}
              record={record}
            />
          ) : (
            <>
              <Grid
                item
                xs={12}
              >
                <ArrayField
                  source="commissions"
                  label=""
                >
                  <Datagrid
                    bulkActionButtons={false}
                    rowClick={false}
                    sx={[
                      settings.style.detailsDatagrid,
                      { "& .RaDatagrid-headerCell": { textAlign: "left" }, width: "100%", mb: 1 },
                    ]}
                  >
                    <TextField
                      source="commissionNumber"
                      label="Комисия #"
                      sortable={false}
                    />
                    <ProfessorField
                      source="employeeId"
                      label="Служител"
                    />
                    <SelectField
                      source="role"
                      label="Роля"
                      choices={ExamCommissionRoles}
                      sortable={false}
                      emptyText="-"
                    />
                  </Datagrid>
                </ArrayField>
              </Grid>
              <SecuredComponent permission={permissions.canManageStateExamCommission}>
                <Button
                  variant="contained"
                  startIcon={<EditIcon />}
                  label="Редактирай"
                  onClick={handleProfessorEditClick}
                  sx={{ mt: 1, ml: 2 }}
                />
              </SecuredComponent>
            </>
          )}
        </Grid>
      </SimpleShowLayout>
    </>
  );
};

export default ProfessorsCommission;
